const AppRegister = () =>
    import ( /* webpackChunkName: "page-login" */ '@/modules/register/AppRegister')

export default [{
    path: '/appregister',
    name: 'appregister',
    component: AppRegister,
    meta: {
        needLogin: false,
        fullscreen: true,
        title: 'app注册',
    },
}, ]